import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3033';
const base = `${apiUrl}/api/domains`;

export const listDomains = () => axios.get(base).then((r) => r.data.domains);
export const createDomain = (domain) => axios.post(base, {domain}).then((r) => r.data.domain);
export const deleteDomain = (id) => axios.delete(`${base}/${id}`).then((r) => r.data);
